import { AgentModel, AgentRelationModel, AgentRelationState } from '../../../../../gamma-api';

export const MAIN_CLASS_NAME = 'agent-relations-tab';
export const EMPTY_CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__empty-content`;
export const EMPTY_CONTENT_PLACEHOLDER_CLASS_NAME = `${EMPTY_CONTENT_CLASS_NAME}__placeholder`;
export const SKELETON_CONTAINER_CLASS_NAME = `${MAIN_CLASS_NAME}__skeleton-container`;

export const SKELETON_HEIGHT = 32;
export const SKELETON_WIDTH = 384;

export const RELATIONS_PAGE_SIZE = 30;

export const EMPTY_AGENT_RELATION: AgentRelationModel = {
  relation_id: '',
  folder_id: '',
  managing_agent: ({} as unknown) as AgentModel,
  managed_agent: ({} as unknown) as AgentModel,
  state: AgentRelationState.Enabled,
  handoff: { description: null },
};
